import { render, staticRenderFns } from "./SelectChecklist.vue?vue&type=template&id=56fde3b2"
import script from "./SelectChecklist.vue?vue&type=script&lang=js"
export * from "./SelectChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports